import { traverseTree, isGroupMenu } from '.'

export const findMenuInfoByPath = (menuTree, path, matchFunc) => {
  let menu
  let subMenu
  let matchedSubMenu
  let parentMenus

  if (path) {
    traverseTree(menuTree, (menu, pnode, pnodes) => {
      if (!isGroupMenu(menu)) {
        if (menu?.path === path) {
          subMenu = menu
          menu = pnode
          parentMenus = pnodes
          return false
        }

        if (!matchedSubMenu && matchFunc && matchFunc(menu)) {
          matchedSubMenu = menu
          menu = pnode
          parentMenus = pnodes
        }
      }
    })

    return {
      subMenu,
      matchedSubMenu,
      menu,
      parentMenus,
    }
  }

  return { subMenu, menu, parentMenus }
}

export default findMenuInfoByPath
